import React, { useEffect } from "react";

import MissedCall from "../../assets/product/Missed-Call.png";
import MissedCallHERO from "../../assets/product/missed-call-Hero.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faUsers,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import OurClients from "../OurClients/OurClients";
import Aos from "aos";
import BgImg from "../../assets/portfolio/bg2.png";
import LeadGenerationServices from "../Website/LeadGenerationServices";
const MissedCallAlert = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);
  const cards = [
    {
      icon: faPhone,
      title: "Call Capture",
      description: "Efficiently handle all calls with ease.",
      animation: "fade-up",
    },
    {
      icon: faEnvelope,
      title: " Real-Time Alerts",
      description: "Stay informed with instant alerts.",
      animation: "fade-up",
    },
    {
      icon: faUsers,
      title: "Data Analytics",
      description: "Enhance productivity with teamwork.",
      animation: "fade-up",
    },
    {
      icon: faChartBar,
      title: "Automation Integration",
      description: "Analyze and improve your operations.",
      animation: "fade-up",
    },
  ];
  return (
    <div>
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-blue-600 opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-semibold leading-tight text-[#8cd3fe]">
              Missed Call Alert
            </h1>
            <p className="md:mt-6  mt-4 text-gray-300 text-[15px] md:text-lg">
              Missed Call Alert ensures you never miss an opportunity. Instantly
              capture customer interest with automated alerts for every missed
              call, enabling quick follow-ups and enhanced engagement. Turn
              every missed call into a valuable connection.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={MissedCallHERO}
              alt="misscall"
              className="w-full max-w-md md:max-w-md lg:max-w-md"
            />
          </div>
        </div>
      </div>

      {/* second section */}

      <div className="bg-blue-50 py-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto text-center">
          <h3 className="text-2xl md:text-4xl mb-2 font-semibold">
            Missed Call Alert
          </h3>
          <div className="w-24 md:w-32 h-1 bg-main1 mx-auto mb-5 rounded-full" />
        </div>

        <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="w-full px-2 order-2 lg:order-1">
            <img
              src={MissedCall}
              alt="miss-call"
              className="w-full h-auto object-cover"
            />
          </div>

          <div className="px-2 lg:px-6 order-2 lg:order-1">
            <p className="text-gray-700 md:text-base text-sm text-justify leading-relaxed">
              This service helps you stay in touch even in case of unavoidable
              circumstances such as poor networks. You can get notifications for
              the calls missed on dedicated numbers. Business entities and
              entrepreneurs have started realizing the true potential of Missed
              Call Marketing. With the growing demand for the service from all
              regions, we have gradually expanded our cloud telephony network to
              all four regions in India—North, South, East, and West.
            </p>

            <h4 className="text-justify text-lg md:text-xl mt-1 font-semibold text-main1">
              Benefits of Missed Call Services:
            </h4>
            <ul className="list-disc pl-1 list-inside text-gray-700 mb-5 space-y-1">
              <li>Do not miss out on any lead.</li>
              <li>Get your customers connected.</li>
              <li>Helps in surveys, voting, and campaigning.</li>
              <li>Get quality customers by verifying.</li>
              <li>For getting feedback.</li>
              <li>Save running costs up to 90%.</li>
              <li>Powerful APIs for real-time data.</li>
              <li>24x7 Support & Monitoring.</li>
              <li>CRM integration.</li>
            </ul>
          </div>
        </div>
      </div>
      {/* benifits section */}
      <div
        className="py-5 px-5 relative"
        data-aos="fade-up"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          {/* Main Heading */}
          <h2 className="text-2xl md:text-4xl font-semibold">
            <span className="text-black">Missed Call </span>
            <span className="text-sky-500"> Services</span>
          </h2>

          {/* Decorative Underline */}
          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          {/* Subtext */}
          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our Company’s
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                data-aos={card.animation}
                data-aos-delay={(index + 1) * 100}
              >
                <div className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <FontAwesomeIcon
                      icon={card.icon}
                      size="2x"
                      className="text-main"
                    />
                  </div>
                  <h5 className="md:text-lg text-base  font-semibold text-gray-800 mb-3">
                    {card.title}
                  </h5>
                  <p className=" text-sm text-gray-600">{card.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* lead generation  */}
      <div>
        <LeadGenerationServices />
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default MissedCallAlert;
